export default __webpack_public_path__ + "images/load.03efd3363987e21c48458cd9cd2f6863.svg";